import type { RelationshipType, DataConsent } from './sessionTypes'
import type { ClientTrack } from './clients'

export const SESSION_TYPE_OPTIONS: { id: RelationshipType; label: string }[] = [
  { id: 'practitioner-client', label: 'Practitioner and client'        },
  { id: 'parent-child',        label: 'Practitioner, parent and child' },
  { id: 'co-workers',          label: 'Peers'                          },
  { id: 'other',               label: 'Something else'                 },
]

export const TRACK_OPTIONS: { id: ClientTrack; label: string; explanation: string }[] = [
  {
    id: 'practice',
    label: 'Practice only',
    explanation: 'Session notes saved for you — no research data collected.',
  },
  {
    id: 'research',
    label: 'Research',
    explanation: 'Anonymised data may help us understand how this approach works.',
  },
]

export const DATA_CONSENT_OPTIONS: { id: DataConsent; label: string }[] = [
  {
    id: 'yes',
    label: "Yes, I'm happy for my anonymised data to be used for research",
  },
  {
    id: 'no',
    label: 'No thank you, just save my session notes',
  },
]
